/* eslint-disable no-unused-vars */
export enum CouponTypeEnum {
  Percentage = "PERCENTAGE",
  Amount = "AMOUNT"
};
